import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { QUERY_KEY } from '@/utils';
import { getUserInfo } from '@/services';
import { useGlobalLoading } from './use-global-loading';

export const useUserInfo = () => {
  const { setGlobalLoading } = useGlobalLoading();

  const {
    data: userInfo,
    refetch: refetchUserInfo,
    isLoading: isUserInfoLoading,
    isFetched: isUserInfoFetched,
  } = useQuery({
    queryKey: [QUERY_KEY.CurrentUser],
    queryFn: getUserInfo,
    staleTime: Infinity,
  });

  const isLoading = isUserInfoLoading;

  const isFetched = isUserInfoFetched;

  useEffect(() => {
    if (isLoading) setGlobalLoading(true);
    else setGlobalLoading(false);
  }, [isLoading, setGlobalLoading]);

  return {
    userInfo: userInfo ? { ...userInfo } : null,
    getUserInfo: () => {
      refetchUserInfo();
    },
    isFetched,
  };
};
